import { createStore } from "vuex";
import {
  getModule,
  Module,
  Mutation,
  Action,
  VuexModule,
} from "vuex-module-decorators";

interface conditions {
  view_name: string;
  conditions: Map<string, string>;
}

const searchCondition = createStore({
  state: new Map(),
  mutations: {
    setCondition(state, condition: conditions) {
      state.set(condition.view_name, condition.conditions);
    },
  },
  actions: {},
  modules: {},
});

/**
 * ユーザー属性 Store
 */
@Module({ dynamic: true, store: searchCondition, name: "shopStore" })
class SearchCondition extends VuexModule {
  @Mutation
  async setConditionData(condition: conditions) {
    searchCondition.state.set(condition.view_name, condition.conditions);
  }
  @Mutation
  clearCondition(view_name: string): void {
    searchCondition.state.set(view_name, null);
  }
  @Action
  async setCondition(condition: conditions) {
    this.setConditionData(condition);
  }
  @Action
  async hasCondition(): Promise<boolean> {
    return true;
  }
  @Action
  getCondition(view_name: string): Map<string, string> {
    return searchCondition.state.get(view_name);
  }
}

export default getModule(SearchCondition, searchCondition);
